export default __webpack_public_path__ + "static/media/IUSDP.21483dda.png";